import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import OrderingEzidebitTermsTab from './OrderingEzidebitTermsTab';
import OrderingEmailConfirmationTab from './OrderingEmailConfirmationTab';
import OrderingApprovalTab from './OrderingApprovalTab';
import OrderingApprovalEmailTab from './OrderingApprovalEmailTab';
import OrderTermsSettingsTab from './OrderTermsSettingsTab';
import OrderingSignedPdfEmailTab from './OrderingSignedPdfEmailTab';
import OrderingServiceActiveEmailTab from './OrderingServiceActiveEmailTab';
import OrderingVoiceDIDTab from './OrderingVoiceDIDTab';

interface OrderingSettingsTabProps {
  onError?: (msg: string) => void;
}

const OrderingSettingsTab: React.FC<OrderingSettingsTabProps> = ({ onError }) => {
  const [sub, setSub] = useState(0);
  const subTabSx = {
    textTransform: 'none' as const,
    fontWeight: 500,
    fontSize: '0.875rem',
    minHeight: 40,
    py: 0,
    '&.Mui-selected': { color: 'secondary.main', fontWeight: 600 },
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs
          value={sub}
          onChange={(_, v) => setSub(v)}
          sx={{
            minHeight: 40,
            '& .MuiTabs-indicator': { height: 2, backgroundColor: 'secondary.main' },
          }}
        >
          <Tab label="Ezidebit" sx={subTabSx} />
          <Tab label="Email template" sx={subTabSx} />
          <Tab label="Customer approval" sx={subTabSx} />
          <Tab label="Approval email" sx={subTabSx} />
          <Tab label="Catalogue terms" sx={subTabSx} />
          <Tab label="Approved order email" sx={subTabSx} />
          <Tab label="Service active email" sx={subTabSx} />
          <Tab label="Voice / DID" sx={subTabSx} />
        </Tabs>
      </Box>
      {sub === 0 && <OrderingEzidebitTermsTab onError={onError} />}
      {sub === 1 && <OrderingEmailConfirmationTab onError={onError} />}
      {sub === 2 && <OrderingApprovalTab onError={onError} />}
      {sub === 3 && <OrderingApprovalEmailTab onError={onError} />}
      {sub === 4 && <OrderTermsSettingsTab onError={onError} />}
      {sub === 5 && <OrderingSignedPdfEmailTab onError={onError} />}
      {sub === 6 && <OrderingServiceActiveEmailTab onError={onError} />}
      {sub === 7 && <OrderingVoiceDIDTab onError={onError} />}
    </Box>
  );
};

export default OrderingSettingsTab;
